import {
  CoveredWarrantsDataTypes,
  GetCoveredWarrantsParamsTypes,
  ShareholderTransactionsParamsTypes,
  ShareholderTransactionsTypes,
  OtherInformationTypes,
  OtherInformationParamsTypes,
  ExerciseRightParamsTypes,
  ExerciseRightDataTypes,
  IssuanceMaturityParamsTypes,
} from './types';

import axiosInstance from 'services/common/instance';
import { SGDCKNewsDetailDataTypes } from 'services/news/newsTransBasisDetail/type';

const getShareholderTransactionsService = async (
  params: ShareholderTransactionsParamsTypes,
): Promise<PaginationData<ShareholderTransactionsTypes[]>> => {
  const res = await axiosInstance.get('ttpt-shareholder-transactions', { params });
  return res.data;
};

export const getCoveredWarrantsService = async (
  params: GetCoveredWarrantsParamsTypes,
): Promise<CoveredWarrantsDataTypes[]> => {
  const res = await axiosInstance.get('ttpt-covered-warrants', { params });
  return res.data.data;
};

export const getOtherInformationService = async (
  params: OtherInformationParamsTypes,
): Promise<PaginationData<OtherInformationTypes[]>> => {
  const response = await axiosInstance.get('ttpt-other-information', { params });
  return response.data;
};

export const getExerciseRightsService = async (
  params: ExerciseRightParamsTypes,
): Promise<PaginationData<ExerciseRightDataTypes[]>> => {
  const response = await axiosInstance.get('exercise-rights', { params });
  return response.data;
};

export const getIssuanceMaturityService = async (
  params: IssuanceMaturityParamsTypes,
): Promise<PaginationData<SGDCKNewsDetailDataTypes[]>> => {
  const response = await axiosInstance.get('sgdck-news', { params });
  return response.data;
};

export default getShareholderTransactionsService;
